module.exports = __webpack_public_path__ + "img/member.216c33b6.svg";